export interface DrawingDisplaySettings {
  /** Multiplier applied to the renderer-authored membrane source/roll label size. */
  membraneLabelScale: number;
  /** Multiplier applied to fixing-spacing annotations in membrane/fixing drawings. */
  fixingLabelScale: number;
}

/**
 * The requested default is half of the renderer size that preceded this control.
 * These values affect presentation only; drawing coordinates and engineering
 * calculations remain backend-authoritative.
 */
export const DEFAULT_DRAWING_DISPLAY_SETTINGS: DrawingDisplaySettings = {
  membraneLabelScale: 0.5,
  fixingLabelScale: 0.5,
};

export function clampDrawingLabelScale(value: number): number {
  if (!Number.isFinite(value)) return 0.5;
  return Math.min(2, Math.max(0.1, value));
}
